export default __webpack_public_path__ + "static/media/berny-artworkinfo2.386b4d20.png";